import { DatabaseService } from '../../_services/database.service';
import { LotteryService } from '../../_services/lottery.service';

export class LottolocoTracker
{
    public static saveStatus(databsaeService:DatabaseService,lotteryService:LotteryService)
    {

      
        
        // databsaeService.getCurrentCustomer()
        // .getDocument()
        // .setFields({lastModified: new Date(),deviceType:lotteryService.getDeviceType()})
        // .then();
    }
}